module.exports = __webpack_public_path__ + "web/img/verify2.98761564.png";